import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableRow, TableHead } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Prompt } from 'react-router-dom';
import AllowedStateUserGroupListComponent from '../../allowedStates/edit/AllowedStateUserGroupListComponent';
import {
  TableContainerMaxHeight,
  TableCellStickyColumn,
  TableCellHeaderStickyTopAndLeft,
  TableCellStyledWithHeaderTextValueSmall
} from 'components/list/TableComponentsStyled';
import { RoundedHeaderTableRow } from 'components/common/table/TableStyles';
import { IconButton } from '@totalsoft/rocket-ui';
import FlexBox from 'components/common/FlexBox';

const AllowedStatesListComponent = ({
  allowedStates,
  userGroups,
  onEdit,
  onRemove,
  dispatch,
  changedAllowedStatesPermissions,
  changed
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Prompt when={changed} message={t('LeavingWithoutSaving')} />
      <TableContainerMaxHeight>
        <Table stickyHeader>
          <TableHead>
            <RoundedHeaderTableRow>
              <TableCellHeaderStickyTopAndLeft>{t('DocumentTypes.State')}</TableCellHeaderStickyTopAndLeft>
              {userGroups.map(userGroup => (
                <TableCellStyledWithHeaderTextValueSmall key={userGroup.id}>{userGroup.name}</TableCellStyledWithHeaderTextValueSmall>
              ))}
            </RoundedHeaderTableRow>
          </TableHead>
          <TableBody>
            {allowedStates.map(allowedState => {
              return (
                <TableRow key={allowedState.id} hover>
                  <TableCellStickyColumn>
                    <FlexBox gap={0.5} alignItems='center'>
                      <IconButton
                        color='primary'
                        variant='text'
                        size='tiny'
                        type='edit'
                        tooltip={t('Edit')}
                        onClick={onEdit(allowedState.id)}
                      />
                      <IconButton
                        color='primary'
                        variant='text'
                        size='tiny'
                        type='delete'
                        tooltip={t('Delete')}
                        onClick={onRemove(allowedState.id)}
                      />
                      {allowedState.documentStateName}
                    </FlexBox>
                  </TableCellStickyColumn>
                  <AllowedStateUserGroupListComponent
                    changedAllowedStatesPermission={changedAllowedStatesPermissions[allowedState.id] || {}}
                    userGroups={userGroups}
                    allowedState={allowedState}
                    dispatch={dispatch}
                  />
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainerMaxHeight>
    </>
  );
};

AllowedStatesListComponent.propTypes = {
  allowedStates: PropTypes.array.isRequired,
  userGroups: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  changedAllowedStatesPermissions: PropTypes.object.isRequired,
  changed: PropTypes.bool
};
export default memo(AllowedStatesListComponent);
